import { useState } from 'react'
import { DraggableProvided } from 'react-beautiful-dnd'
import {
  IQuestionBankQuestion,
  IQuestionBankSection,
} from 'interfaces/questionBank'
import Questions from './questions'
import ManageQuestion from './manageQuestion'
import { Wrapper, Content } from './styled'
import Header from './header'
import Description from './description'
import Footer from './footer'
import Actions from './actions'
import EmptyState from './emptyState'

interface IProps {
  section: IQuestionBankSection
  provided: DraggableProvided
}

const Section = ({ section, provided }: IProps) => {
  const [isOpen, setIsOpen] = useState(true)
  const [manageQuestion, setManageQuestion] = useState(false)
  const [isImportingQuestions, setIsImportingQuestions] = useState(false)
  const [question, setQuestion] = useState<IQuestionBankQuestion>()

  const addQuestion = () => {
    setQuestion(undefined)
    setManageQuestion(true)
  }

  const editQuestion = (data: IQuestionBankQuestion) => {
    setQuestion(data)
    setManageQuestion(true)
  }

  return (
    <Wrapper>
      <Header
        section={section}
        provided={provided}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
      <Content open={isOpen}>
        <Description section={section} />
        {section.questions.length ? (
          <>
            <Actions
              section={section}
              addQuestion={addQuestion}
              importQuestions={() => setIsImportingQuestions(true)}
            />
            <Questions section={section} editQuestion={editQuestion} />
            <Footer section={section} />
          </>
        ) : (
          <EmptyState
            addQuestion={addQuestion}
            importQuestions={() => setIsImportingQuestions(true)}
          />
        )}
        {manageQuestion && (
          <ManageQuestion
            data={question}
            section={section}
            close={() => setManageQuestion(false)}
          />
        )}
      </Content>
    </Wrapper>
  )
}

export default Section
